<div class="ai-prompt-container">
  
  <!-- Search and Filter Bar -->
  <div class="filter-container">
    <div class="search-section">
      <app-search-inline 
        [placeholderStr]="'Search prompts by name, description, or content'" 
        (keywordChange)="search($event)"
        data-cy="search-prompt-inline-wrapper">
      </app-search-inline>
      
      <!-- Filter Button with Dropdown -->
      <div class="filter-dropdown">
        <rubii-button 
          icon="filter" 
          buttonType="icon" 
          [matMenuTriggerFor]="categoryMenu"
          matTooltip="Filter by category">
        </rubii-button>
        
        <mat-menu #categoryMenu="matMenu">
          <button mat-menu-item (click)="filterByCategory(null)">
            <span>All Categories</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item 
                  *ngFor="let category of categories" 
                  (click)="filterByCategory(category._id)">
            <span>{{category.name}}</span>
          </button>
        </mat-menu>
      </div>
    </div>
    
    <!-- Add New Prompt Button -->
    <button 
      mat-raised-button 
      class="rubii-btn add-btn" 
      color="primary" 
      (click)="createOrUpdatePrompt(null)" 
      data-cy="add-new-prompt-btn">
      <mat-icon [inline]="true">add</mat-icon> Add New Prompt
    </button>
  </div>

  <!-- Prompts Table -->
  <div class="rubii-table">
    <table style="max-width: 100%">
      <thead>
        <tr>
          <th class="category-th">Prompt Category</th>
          <th class="name-th">Prompt Name</th>
          <th class="description-th">Prompt Description</th>
          <th class="usage-th">Used</th>
          <th class="actions-th">Actions</th>
          <th class="date-th">Date Created</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!prompts || prompts.length === 0" style="text-align: center">
          <td colspan="5" class="no-data-message">
            <div *ngIf="keyword || selectedCategoryId !== null; else noPromptsMessage">
              No prompts found matching your search criteria.
            </div>
            <ng-template #noPromptsMessage>
              <div>No prompts available. <a href="javascript:void(0)" (click)="createOrUpdatePrompt(null)">Create your first prompt</a></div>
            </ng-template>
          </td>
        </tr>
        
        <tr *ngFor="let prompt of prompts" class="prompt-row">
          <td class="category-td">
            <span class="category-name">{{getCategoryName(prompt.categoryId)}}</span>
          </td>
          
          <td class="name-td">
            <div class="prompt-name-container">
              <div class="prompt-name" [title]="prompt.name">{{prompt.name}}</div>
              <div class="prompt-built-in" *ngIf="prompt.builtIn">
                <span class="built-in-badge">Built-in</span>
              </div>
            </div>
          </td>
          
          <td class="description-td">
            <div class="prompt-description" [title]="prompt.description">
              {{prompt.description}}
            </div>
          </td>

          <td class="usage-td">
            <span>{{prompt.count}}</span>
          </td>
          
          <td class="actions-td">
            <div class="action-buttons" fxLayout="row" fxLayoutAlign="start center">
              <rubii-button 
                *ngIf="userIsAdmin || !prompt.builtIn"
                icon="edit" 
                buttonType="icon" 
                (onClick)="createOrUpdatePrompt(prompt)"
                matTooltip="Edit"
                data-cy="edit-prompt-btn">
              </rubii-button>
              
              <rubii-button 
                icon="copy" 
                buttonType="icon" 
                (onClick)="duplicatePrompt(prompt)"
                matTooltip="Duplicate"
                data-cy="duplicate-prompt-btn">
              </rubii-button>
              
              <rubii-button 
                icon="delete" 
                buttonType="icon" 
                (onClick)="deletePrompt(prompt)"
                matTooltip="Delete"
                data-cy="delete-prompt-btn"
                *ngIf="!prompt.builtIn">
              </rubii-button>
            </div>
          </td>
          
          <td class="date-td">
            <span *ngIf="prompt.createdate">{{prompt.createdate | date:format:timezone}}</span>
            <span *ngIf="!prompt.createdate">-</span>
          </td>
        </tr>

        <!-- Pagination Row -->
        <tr>
          <td colspan="5">
            <mat-paginator 
              color="primary" 
              (page)="pageChanged($event)" 
              [length]="page.total"
              [pageSize]="page.pageSize" 
              showFirstLastButtons="true" 
              [pageIndex]="page.pageId - 1"
              [pageSizeOptions]="[6, 10, 25, 50]"
              data-cy="prompt-paginator">
            </mat-paginator>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>